var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "interface",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.98,
    height: 24.98,
    viewBox: "0 0 24.98 24.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    "data-name": "Group 2227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    "data-name": "Group 2226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4268",
    "data-name": "Path 4268",
    d: "M12.49,0A12.49,12.49,0,1,0,24.98,12.49,12.483,12.483,0,0,0,12.49,0Zm0,23.315A10.825,10.825,0,1,1,23.315,12.49,10.837,10.837,0,0,1,12.49,23.315Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(11.657 10.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    "data-name": "Group 2228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4269",
    "data-name": "Path 4269",
    d: "M239.763,209.777a.833.833,0,0,0-.833.833v7.024a.833.833,0,0,0,1.665,0V210.61A.833.833,0,0,0,239.763,209.777Z",
    transform: "translate(-238.93 -209.777)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(10.825 6.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4270",
    "data-name": "Path 4270",
    d: "M223.532,124.122a1.665,1.665,0,1,0,1.665,1.665A1.667,1.667,0,0,0,223.532,124.122Z",
    transform: "translate(-221.867 -124.122)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDetails);
export default __webpack_public_path__ + "static/media/more-details.cb79dadbe235c0feda7f24a030321737.svg";
export { ForwardRef as ReactComponent };